
/**
 * Represents the state of a save operation.
 */
export class SaveState {
  /**
   * Gets if the save operation completed successfully
   */
  success: boolean = false;

  /**
   * Gets if the save operation performed was for live or the users' workspace.
   */
  isLive: boolean = true;

  /**
   * Gets the message associated with the save operation.
   */
  shouldReload: boolean = false;
}
